import moment from "moment";
import { DATE_FORMATS, parse } from "utils/Date";

export function getFirstLast(plannedTreatment) {
  let first = null;
  let last = null;

  plannedTreatment.forEach(treatment => {
    const fromDate = moment(
      treatment.planned_date_time_from,
      DATE_FORMATS.BUMBAL,
    );
    const toDate = moment(treatment.planned_date_time_to, DATE_FORMATS.BUMBAL);

    if (first === null || first.isAfter(fromDate)) {
      first = fromDate;
    }
    if (last === null || last.isBefore(toDate)) {
      last = toDate;
    }
  });

  return { first, last };
}

export function toMoment(date) {
  if (typeof date === "object") {
    return date.clone();
  }
  return moment(date, DATE_FORMATS.BUMBAL);
}

export function overlap(timeBlockA, timeBlockB) {
  // Parse dates
  const fromA = parse(timeBlockA.planned_date_time_from, DATE_FORMATS.BUMBAL);
  const fromB = parse(timeBlockB.planned_date_time_from, DATE_FORMATS.BUMBAL);
  const toA = parse(timeBlockA.planned_date_time_to, DATE_FORMATS.BUMBAL);
  const toB = parse(timeBlockB.planned_date_time_to, DATE_FORMATS.BUMBAL);

  // Check
  if (fromA.isAfter(fromB, "minutes")) {
    if (fromA.isBefore(toB, "minutes")) {
      return true;
    }
  }

  if (fromA.isSameOrBefore(fromB, "minutes")) {
    if (toA.isAfter(fromB, "minutes")) {
      return true;
    }
  }

  // All checks failed.
  return false;
}

export function buildTimes(date) {
  const fromDate = date ? date.clone() : moment();
  fromDate
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .hours(8);

  const toDate = date ? date.clone() : moment();
  toDate
    .minutes(0)
    .seconds(0)
    .milliseconds(0)
    .hours(17);

  return {
    planned_date_time_from: fromDate,
    planned_date_time_to: toDate,
    get fromDate() {
      return this.planned_date_time_from.clone();
    },
    get toDate() {
      return this.planned_date_time_to.clone();
    },
  };
}
